<template>
  <div>
    <BaseButton primary outline @click="openDialog"> Add to List </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.$modal.show({
        component: () => import('./AddContactsToListDialog.vue'),
        props: {
          query: this.query,
          accountId: this.accountId,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
